module.exports = __webpack_public_path__ + "img/qr-mobile.a3de429e.svg";